import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthHandling } from "./baseQuery";

export const categoryApi = createApi({
  reducerPath: "categoryApi",
  baseQuery: baseQueryWithAuthHandling,
  tagTypes: ["Categories"],
  endpoints: (builder) => ({
    getCategories: builder.query({
      query: (arg) => {
        let page = 1;
        let search = "";
        if (typeof arg === "number") page = arg;
        else if (arg && typeof arg === "object") {
          page = arg.page || 1;
          search = arg.search || "";
        }
        return {
          url: "/category",
          method: "GET",
          params: { page, ...(search && { search }) },
        };
      },
      providesTags: ["Categories"],
    }),
    createCategory: builder.mutation({
      query: (name) => ({
        url: "/category",
        method: "POST",
        body: name,
      }),
      invalidatesTags: ["Categories"],
    }),
    updateCategory: builder.mutation({
      query: ({ id, name }) => ({
        url: `/category/${id}`,
        method: "PATCH",
        body: { name },
      }),
      invalidatesTags: ["Categories"],
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
} = categoryApi;
